var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "campervan",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240,104H8A8,8,0,0,1,8,88H240a8,8,0,0,1,0,16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dcdcdc",
    d: "M8,368H504a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H24A16,16,0,0,1,8,384V368A0,0,0,0,1,8,368Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,408H360a8,8,0,0,1,0-16H488a8,8,0,0,0,8-8v-8H16v8a8,8,0,0,0,8,8H320a8,8,0,0,1,0,16H24A24,24,0,0,1,0,384V368a8,8,0,0,1,8-8H504a8,8,0,0,1,8,8v16A24,24,0,0,1,488,408Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    d: "M504,282.83V368H296V152H405.76a16,16,0,0,1,14.53,9.3L464,256l29.94,12A16,16,0,0,1,504,282.83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 24,
    x: 296,
    y: 344,
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504,376H296a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8H405.76a24.07,24.07,0,0,1,21.79,13.94l42.38,91.81,27,10.8A23.87,23.87,0,0,1,512,282.83V368A8,8,0,0,1,504,376ZM304,360H496V282.83a8,8,0,0,0-5-7.43l-29.94-12a8,8,0,0,1-4.29-4.08L413,164.65a8,8,0,0,0-7.27-4.65H304Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6f6",
    d: "M400,152V88a16,16,0,0,0-16-16H224l-56,56H8V368H296V152Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 288,
    height: 24,
    x: 8,
    y: 344,
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,376H8a8,8,0,0,1-8-8V128a8,8,0,0,1,8-8H164.69l53.65-53.66A8,8,0,0,1,224,64h32a8,8,0,0,1,0,16H227.31l-53.65,53.66A8,8,0,0,1,168,136H16V360H288V152a8,8,0,0,1,8-8h96V88a8,8,0,0,0-8-8H288a8,8,0,0,1,0-16h96a24,24,0,0,1,24,24v64a8,8,0,0,1-8,8H304V368A8,8,0,0,1,296,376Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,136a8,8,0,0,1-8-8V96a8,8,0,0,1,16,0v32A8,8,0,0,1,24,136Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 144,
    x: 176,
    y: 224,
    fill: "#596060"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 24,
    x: 176,
    y: 224,
    fill: "#4c5657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,376H176a8,8,0,0,1-8-8V224a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8V368A8,8,0,0,1,256,376Zm-72-16h64V232H184Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 64,
    x: 56,
    y: 160,
    fill: "#a8edfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,232H56a8,8,0,0,1-8-8V160a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64A8,8,0,0,1,136,232ZM64,216h64V168H64Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    x: 56,
    y: 256,
    fill: "#a8edfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,312H56a8,8,0,0,1-8-8V256a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v48A8,8,0,0,1,136,312ZM64,296h64V264H64Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 392,
    r: 48,
    fill: "#596060"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c5657",
    d: "M96,416a48,48,0,0,1-46.49-36,48,48,0,1,0,93,0A48,48,0,0,1,96,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,448a56,56,0,1,1,56-56A56.06,56.06,0,0,1,96,448Zm0-96a40,40,0,1,0,40,40A40,40,0,0,0,96,352Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 392,
    r: 16,
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,416a24,24,0,1,1,24-24A24,24,0,0,1,96,416Zm0-32a8,8,0,1,0,8,8A8,8,0,0,0,96,384Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 392,
    r: 48,
    fill: "#596060"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4c5657",
    d: "M400,416a48,48,0,0,1-46.49-36,48,48,0,1,0,93,0A48,48,0,0,1,400,416Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,448a56,56,0,1,1,56-56A56.06,56.06,0,0,1,400,448Zm0-96a40,40,0,1,0,40,40A40,40,0,0,0,400,352Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 392,
    r: 16,
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,416a24,24,0,1,1,24-24A24,24,0,0,1,400,416Zm0-32a8,8,0,1,0,8,8A8,8,0,0,0,400,384Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a8edfd",
    points: "464 256 344 256 344 184 430.77 184 464 256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,264H344a8,8,0,0,1-8-8V184a8,8,0,0,1,8-8h86.77a8,8,0,0,1,7.26,4.65l33.23,72A8,8,0,0,1,464,264ZM352,248h99.5l-25.85-56H352Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ead590",
    d: "M472,328h32V296H472a16,16,0,0,0,0,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 336H472a24 24 0 010-48h32a8 8 0 018 8v32A8 8 0 01504 336zm-32-32a8 8 0 000 16h24V304zM360 296H344a8 8 0 010-16h16a8 8 0 010 16zM368 120H352a8 8 0 010-16h16a8 8 0 010 16z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.7be9e0b90cb6b27e089f5fae2b71f922.svg";
export { ForwardRef as ReactComponent };